<template>
	<!-- <div class="blog-post pall20">
		<div class="row">
			<div class="col-md-12">
				<h5>Usuarios activos</h5>
			</div>
		</div>
		<div class="row stats-solo">
			<div class="col-md-9" style="height:1000px;">
				<vue-chart
					chart-type="Line"
					:packages="['line']"
          :columns="chartCols"
          :rows="chartData"
          :options="chartOptions">
        </vue-chart>
        <br><br>
				<vue-chart
					chart-type="LineChart"
					:packages="['corechart']"
          :columns="chartCols"
          :rows="chartData"
          :options="chartOptions">
        </vue-chart>
        <br><br>
        <custom-chart
					chart-type="Line"
					:packages="['line']"
          :columns="chartCols"
          :rows="chartData"
          :options="chartOptions">
        </custom-chart>
			</div>
			<div class="col-md-3">
				
			</div>
		</div>
	</div> -->

  <!-- <div>
    <div class="row">
      <div class="col-md-9">
        <div class="blog-post pall20">
          <h5>Usuarios activos</h5>
        </div>
      </div>
      <div class="col-md-3">
        <div class="blog-post pall20">
          <h5>Menu</h5>
          <a href="#"><span class="fa fa-group"></span> Usuarios activos</a><br>
          <a href="#"><span class="fa fa-drivers-license-o"></span> Fichas extendidas</a><br>
          <a href="#"><span class="fa fa-search"></span> Búsquedas</a><br>
          <a href="#"><span class="fa fa-cart-plus"></span> Artículos</a><br>
          <a href="#"><span class="fa fa-list-ul"></span> Consultas</a><br>
        </div>
      </div>
    </div>
  </div> -->

  <div>
    <div class="row stats-solo">
      <div class="col-md-2 col-md-offset-0">
        <div class="blog-post">
          <div class="post-content">
            <div class="post-content-inner center">
              <h5><span class="fa fa-group"></span></h5>
              <p>Usuarios activos</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="blog-post">
          <div class="post-content">
            <div class="post-content-inner center">
              <h5><span class="fa fa-search"></span></h5>
              <p>Búsquedas</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="blog-post">
          <div class="post-content">
            <div class="post-content-inner center">
              <h5><span class="fa fa-drivers-license-o"></span></h5>
              <p>Fichas extendidas</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="blog-post">
          <div class="post-content">
            <div class="post-content-inner center">
              <h5><span class="fa fa-cart-plus"></span></h5>
              <p>Artículos</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="blog-post">
          <div class="post-content">
            <div class="post-content-inner center">
              <h5><span class="fa fa-list-ul"></span></h5>
              <p>Consultas</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="blog-post">
          <div class="post-content">
            <div class="post-content-inner center">
              <h5>FECHAS</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="blog-post pall20 mt50">
      <div class="row">
        <div class="col-md-12">

          <h3 class="">Usuarios activos</h3>

          <vue-chart
            chart-type="LineChart"
            :packages="['corechart']"
            :columns="chartCols"
            :rows="chartData"
            :options="chartOptions"
            style="height: 400px;"
            class="mt50">
          </vue-chart>
          
          <table class="table table-hover mt50" style="width:30%"><thead><tr><th width="40"></th> <th>Categoría</th> <th class="right"><i class="fa fa-line-chart"></i></th> <th class="right">Cantidad</th></tr></thead> <tfoot><tr><th></th> <th>Total:</th> <th class="right"><span><span class="">0</span></span></th> <th class="right">374.776</th></tr></tfoot> <tbody><tr><td class="padding0"><span class="box uc bg-libros">L</span></td> <td>Libros</td> <td class="right"><span><span class="">0</span></span></td> <td class="right">146.082</td></tr><tr><td class="padding0"><span class="box uc bg-cine">C</span></td> <td>Cine</td> <td class="right"><span><span class="">0</span></span></td> <td class="right">26.457</td></tr><tr><td class="padding0"><span class="box uc bg-musica">M</span></td> <td>Música</td> <td class="right"><span><span class="">0</span></span></td> <td class="right">160.932</td></tr><tr><td class="padding0"><span class="box uc bg-infantil">I</span></td> <td>Infantil</td> <td class="right"><span><span class="">0</span></span></td> <td class="right">36.114</td></tr><tr><td class="padding0"><span class="box uc bg-series">S</span></td> <td>Series</td> <td class="right"><span><span class="">0</span></span></td> <td class="right">3.587</td></tr><tr><td class="padding0"><span class="box uc bg-documentales">D</span></td> <td>Documentales</td> <td class="right"><span><span class="">0</span></span></td> <td class="right">1.604</td></tr></tbody></table>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
	import axios from 'axios';  
	import { mapGetters   } from 'vuex';

	export default {
		components: {  },
    data: () => {
      return {
				loading: false,
				chartCols: [
					{ "type": "date", "label": "Time of Day" },
					{ "type": "number", "label": "Usuarios activos" }
				],
				chartData: [
					[new Date(2015, 0, 1), 5],  [new Date(2015, 0, 2), 7],  [new Date(2015, 0, 3), 3],
          [new Date(2015, 0, 4), 1],  [new Date(2015, 0, 5), 3],  [new Date(2015, 0, 6), 4],
          [new Date(2015, 0, 7), 3],  [new Date(2015, 0, 8), 4],  [new Date(2015, 0, 9), 2],
          [new Date(2015, 0, 10), 5], [new Date(2015, 0, 11), 8], [new Date(2015, 0, 12), 6],
          [new Date(2015, 0, 13), 3], [new Date(2015, 0, 14), 3], [new Date(2015, 0, 15), 5],
          [new Date(2015, 0, 16), 7], [new Date(2015, 0, 17), 6], [new Date(2015, 0, 18), 6],
          [new Date(2015, 0, 19), 3], [new Date(2015, 0, 20), 1], [new Date(2015, 0, 21), 2],
          [new Date(2015, 0, 22), 4], [new Date(2015, 0, 23), 6], [new Date(2015, 0, 24), 5],
          [new Date(2015, 0, 25), 9], [new Date(2015, 0, 26), 4], [new Date(2015, 0, 27), 9],
          [new Date(2015, 0, 28), 8], [new Date(2015, 0, 29), 6], [new Date(2015, 0, 30), 4],
          [new Date(2015, 0, 31), 6], [new Date(2015, 1, 1), 7],  [new Date(2015, 1, 2), 9]
        ],
				chartOptions:{
					theme: 'material',
					legend:{
						position: 'top',
						alignment: 'center'
					},
					pointSize: 7,
					dataOpacity: 0.3,
					height: 400,
          chartArea: {'width': '95%', 'height': '85%', },
          hAxis: {
            format: 'dd/MM/yy',
            gridlines: {color: 'none'}
          },
          vAxis: {
            minValue: 0,
          },
          fontName: 'Open Sans'
				}
      }
    },
    mounted(){
    	this.loadCharts();
    },
    computed: mapGetters(['getLocale', 'getApiUrl']),
    methods:{	     
    	loadCharts(){
    		this.showLoading();
    		axios.get( this.getApiUrl + this.getLocale + '/tpanel/statsglobal')
          .then( (respuesta) =>{ 
            //console.log(respuesta);
            this.bbdd = respuesta.data.data.bbdd;
            this.web = respuesta.data.data.web;
            this.infantil = respuesta.data.data.infantil;
            this.hideLoading()
          })
        .catch( (error) =>{ 
          this.hideLoading();
          alert(error.response.data.msg);
        });
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    }
	}
</script>
